<template>
  <suspense>
    <article class="teaser-media">
      <figure
        v-click-redirect="{ configPreset: 'teaser-default' }"
        class="teaser-media__figure"
      >
        <r-image
          class="teaser-media__picture"
          :sources="teaser.image.sources"
          :alt="teaser.image.alt"
        />
      </figure>

      <div class="teaser-media__content">
        <div
          v-if="['PODCAST'].includes(extension.type)"
          class="teaser-media__sticker sticker-square"
        >
          <dpc-icon
            class="sticker-square__icon"
            icon="podcast"
            custom-label="Podcast"
          ></dpc-icon>
        </div>
        <div
          v-else-if="['VIDEO', 'STREAM'].includes(extension.type)"
          class="teaser-media__sticker sticker-square"
        >
          <dpc-icon
            class="sticker-square__icon"
            icon="video"
            custom-label="Video"
          ></dpc-icon>
        </div>

        <header class="teaser-media__header">
          <div class="teaser-media__label-tag label-tag">
            <span>
              {{ extension.label }}
            </span>
          </div>
          <h3 class="teaser-media__heading">
            <r-link
              class="teaser-media__link"
              :url="teaser.link.url"
              :target="teaser.link.target"
            >
              {{ title }}
            </r-link>
          </h3>
        </header>
      </div>
    </article>
  </suspense>
</template>

<script setup>
import { useExtension } from '@components/organisms/api/extensions/use-extension.composable.js';
import { toRefs } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const { data } = toRefs(props);

const { teaser, extension, title } = useExtension({ data });
</script>
